import React, {useEffect, useRef, useState} from 'react';
import MobileNav from '../Components/MobileNav';
import styled from "styled-components"
// import GetGlobalStyle from '../Components/JS-CSS/Global';
import history from '../history'
// import Notify from '../Components/Notify/notify';
 import axios from "axios"
 import apiM from '../GlobalEnv'

const BOTTOM = styled.section`
display: flex;
    justify-content: space-between;
    margin-top: 68vh;
    padding-right: 12rem;
    font-size: .9rem;

`

const FORM = styled.section`
font-size: small;
form {
    display: flex;
    flex-flow: column;
    align-items: center;

    button {
        display: ${({btn}) => btn === true ? 'none' : 'inline-block'};
        transition: ease-in-out 1.2s;
        cursor: pointer;
        margin-top: 3rem;
    width: 75%;
    justify-self: center;
    align-self: center;
    padding: .5rem;
    color: white;
    background: #382842;
    border: none;
    outline: none;
    border-radius: .5rem;
    /* background-color: white; */
    box-shadow: 1px 2px 2px 1px #d6d0d0;
    }

    section {
        display: flex;
        margin-left: 9rem;
        width: 7rem;
        justify-content: space-around;
        align-items: center;
        margin-top: 1rem;
    }
    input[type=email]:first-of-type {
        // display: none;
        margin: 85px auto auto;
    }
    input:first-of-type + input {
        margin: 65px auto auto;
     }
    
    input[type=email], input[type=password] {

        display: block;
        padding: 1rem .5rem;
        width: 70%;
        width: 100%;
        border-bottom: 3px solid rgba(38, 20, 49, 0.97);
        border-top: transparent;
        border-left: transparent;
        border-right: transparent;
        font-size: 14px;
        text-indent: 7px;
        text-transform: lowercase;
        line-height: 28px;
        text-align: justify;
    }
}
@media screen and (max-width: 48rem) {
    width: 100%;
    margin: 0;
}
margin-right: 5%;
width: 55%;
height: 4rem;
align-items: center;
margin-left: 0rem;
  
h1 {
    text-align: center;
 height: 42px;
 margin-top: 40px;

font-family: Roboto;
font-style: normal;
font-weight: 900;
font-size: 30px;
line-height: 47px;

color: #261431;
}
img {
    @media screen and (min-width: 48rem) {
          display: none;
    }


}
`
const HEADER = styled.nav`
font-size: small;
form {

    section {
        display: flex;
        margin-left: 9rem;
        width: 7rem;
        justify-content: space-around;
        align-items: center;
        margin-top: 1rem;
    }
    input[type=email]:first-of-type {
        // display: none;
        margin: 85px auto auto;
    }
    input:first-of-type + input {
        margin: 65px auto auto;
     }
    
    input[type=email], input[type=password] {

        display: block;
        padding: 1rem .5rem;
        width: 70%;
        width: 60%;
        border-bottom: 3px solid rgba(38, 20, 49, 0.97);
        border-top: transparent;
        border-left: transparent;
        border-right: transparent;
        font-size: 14px;
        text-indent: 7px;
        text-transform: lowercase;
        line-height: 28px;
        text-align: justify;
    }
}
@media screen and (max-width: 48rem) {
    width: 100%;
    margin: 0;
}
margin-right: 5%;
width: 55%;
height: 4rem;
align-items: center;
margin-left: 0rem;
  
h1 {
    text-align: center;
 height: 42px;
 margin-top: 40px;

font-family: Roboto;
font-style: normal;
font-weight: 900;
font-size: 30px;
line-height: 47px;

color: #261431;
}
img {
    @media screen and (min-width: 48rem) {
          display: none;
    }


}
`

const SECTION = styled.section`
overflow: hidden;
display: flex;
justify-content: space-between;

aside {
    width: 45vw;
    @media screen and (max-width: 48rem) {
        width: 100vw;
    padding-left: 3rem;
    padding-right: 3rem;
    }

}

figure {
@media screen and (max-width: 48rem) {
    display: none;
}
    width: 35%;

    img {
        height: 100vh;
        width: 100%;
        overflow: hidden;
    }
}
@media screen and (max-width: 48rem) {

    figure {
        display: none;
    }
}
`

const Login = () => {

        const check = useRef(null);
        const[mail, setMail] = useState('')
        const[pass, setPass] = useState('')
        // const[msg, setMsg] = useState('')
        const[disp, setDisp] = useState(false)
 
    useEffect(() => {document.title = 'Login'})

  const handleSubmit = async (e) => {
        
        e.preventDefault();

        setDisp(true)

      sessionStorage.setItem('mail', mail)

 


    const mainAPI =  apiM + "/login/oldUser/"

 
try {
    let data = {
        email: mail,
        password: pass
     }
       
    let res = await axios.post(mainAPI, data)
    // let res = await fetch(mainAPI, init)
     let {success, err, lStr} = await res.data
    
    if(success) {
        sessionStorage.setItem('lStr', lStr)
        // setTimeout(() => history.push(`/wall/${mail}`) , 1100);
        setTimeout(() => history.push(`/dashboard`) , 1100);
    }

    if(err) throw err
    }

 catch (e) {

            console.log(e)
            alert(e)
            setDisp(false)

// if(e.message === 'Failed to fetch') {
//         alert('Network error, pls check your network and retry')
//      }

// else {
//          alert("error occured pls refresh or try again")
//      }
}


        // alert(check.current.checked)

    }

    return (

        <>
         {/* <GetGlobalStyle 
        hei={'100vh'}
        overF={`hidden`} 
        />  */}
<MobileNav />

{/* <Notify msg={msg} /> */}

        <SECTION>

            <figure>

            <img 
            src={require('../Assets/Images/lWealth.png')}
            alt="wealth login"
             />

             </figure>

             <aside>
  <HEADER>

            {/* <img src={require('../Assets/Images/arrow-back.svg')} alt="go back toprevious page" /> */}

            <h1 id="dashH">Iamwealthy</h1>

             </HEADER>

             <FORM btn={disp}>
             <form onSubmit={e =>handleSubmit(e)} >

 
<input 
type="email" 
name="email" 
required
placeholder={`Your email address`}
onChange={({target}) => setMail(target.value)}
autoComplete="username"
 />


<input 
type="password" 
name="password" 
required
placeholder="Your password" 
onChange={({target}) => setPass(target.value)}
autoComplete="current-password"

/>

<section>
 <input 
type="checkbox" 
name="checkbox" 
ref={check}
/>
<small>keep me logged in</small>

</section>

<button type="submit" >  Submit </button>
 <img src={require('../Assets/Preloaders/25.gif')} alt='confirming payment' style={disp === false ? {display:'none'}: {display:'block', height: '3rem', width:'3rem', marginTop: '2rem'}} />
</form>


             </FORM>

        
<BOTTOM>
    {/* <section>
        partOne
    </section>

    <section>
        partTwo
    </section> */}

</BOTTOM>


             </aside>

          




        </SECTION>






        </>
    )
}

export default Login